import Script from 'next/script';

export interface JentisProps {
  url: string | undefined;
}

export const Jentis = ({ url }: JentisProps) =>
  url ? (
    <>
      <Script id="jentis-init" strategy="afterInteractive" data-testid="jentis-init">
        {`window._jts = window._jts || [];
_jts.push({ track: "pageview" });
_jts.push({ track: "submit" });`}
      </Script>
      <Script id="jentis-sdk" src={url} strategy="afterInteractive" data-testid="jentis-sdk" />
    </>
  ) : null;
